// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMessageSquareMore as RawLucideMessageSquareMore } from "lucide-react";
export const LucideMessageSquareMore = /* @__PURE__ */ createIcon(RawLucideMessageSquareMore, "LucideMessageSquareMore", 2);
